import React from 'react'
import injectStyles from 'react-jss'
import { styles } from '../../styles'
import { useHistory } from 'react-router-dom'
import { PATHS } from '../../../../Config/Routing/paths'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import { PageTitle } from '../../../../Components/PageTitle'
import Card from '../../components/Card'
import SwellIcon from '../../icons/SwellIcon'
import ArrowBackIcon from '../../icons/ArrowBackIcon'
import BreadcrumbsSettingsIcon from '../../../../Assets/Images/icons/breadcrumbsSettings'
import classNames from 'classnames'
// import CSVIcon from '../../icons/CSV'

const CouponsType = ({ classes, url }) => {
  const history = useHistory()

  const CARDS = [
    {
      title: 'Swell',
      description: (
        <span>
          Sync your codes with your
          <br />
          Swell stores.
        </span>
      ),
      buttonText: 'Select Store',
      icon: <SwellIcon />,
      onClick: () => {
        const urlSearchParams = new URLSearchParams(history.location.search)
        const redirectURL = urlSearchParams.get('redirectURL')

        history.push(
          `${url}${PATHS.clientSettings.coupons}${
            PATHS.clientSettings.createCoupon
          }${PATHS.clientSettings.stores}${
            redirectURL ? `?redirectURL=${redirectURL}` : ''
          }`,
        )
      },
    },
    // {
    //   title: 'CSV',
    //   description: (
    //     <span>
    //       Choose a CSV file of unique
    //       <br />
    //       codes
    //     </span>
    //   ),
    //   buttonText: 'Upload CSV',
    //   icon: <CSVIcon />,
    //   onClick: () => {
    //     history.push(
    //       `${url}${PATHS.clientSettings.coupons}${
    //         PATHS.clientSettings.createCoupon
    //       }${PATHS.clientSettings.csvUpload}`,
    //     )
    //   },
    // },
  ]

  const onBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
        PATHS.clientSettings.coupons
      }`,
    )
  }

  return (
    <div className={classes.container}>
      <StyledBreadcrumbs
        icon={<BreadcrumbsSettingsIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.coupons
            }`,
            label: 'Coupons',
          },
          {
            label: 'Create Coupon',
          },
        ]}
      />
      <PageTitle className={classes.title}>
        <div className={classes.back} onClick={onBack}>
          <ArrowBackIcon />
        </div>
        <div>Coupons</div>
      </PageTitle>
      <div className={classes.description}>Select a coupon type</div>
      <div className={classNames(classes.cardWrapper, 'cardWrapper')}>
        {CARDS.map(card => (
          <Card
            title={card.title}
            description={card.description}
            buttonText={card.buttonText}
            icon={card.icon}
            onClick={card.onClick}
          />
        ))}
      </div>
    </div>
  )
}

export default injectStyles(styles)(CouponsType)
